/**
 * mSTEM Phase 6 / EXT-02 Block Builder option lists + color palette
 * (DR-02 / UI-SPEC, MOCK-ONLY). Seed data for the block-shape dropdown,
 * the per-input type dropdown, and the preset color swatches that fill the
 * live SVG block-preview silhouette. 06-03 wires the i18n labels
 * (gen.ext.block.shape.* / .inputType.*); these ids stay ASCII/stable.
 */

// Block silhouette shapes (COMMAND/REPORTER/BOOLEAN/HAT) — drives BlockPreview.
const SHAPES = [
    {id: 'command'},
    {id: 'reporter'},
    {id: 'boolean'},
    {id: 'hat'}
];

// Per-input value types for the inputs list (add/remove rows).
const INPUT_TYPES = [
    {id: 'number'},
    {id: 'text'},
    {id: 'boolean'},
    {id: 'menu'}
];

// 8 preset block-color swatches derived from Scratch/OpenBlock category hues
// so user blocks look native (UI-SPEC EXT-02). These are CONTENT colors the
// user paints with — not mSTEM brand chrome.
const COLOR_SWATCHES = [
    '#4C97FF', // motion blue
    '#9966FF', // looks purple
    '#CF63CF', // sound pink
    '#FFAB19', // control orange
    '#5CB1D6', // sensing sky
    '#59C059', // operators green
    '#FF8C1A', // data orange
    '#0FBD8C' // extensions teal
];

const DEFAULT_SWATCH = '#9966FF';

export {
    SHAPES,
    INPUT_TYPES,
    COLOR_SWATCHES,
    DEFAULT_SWATCH
};
